module.exports = __webpack_public_path__ + "static/img/app_store.addc027.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/app_store.png
// module id = DeuE
// module chunks = 0